import React from 'react';
export function Footer() {
  return <footer className="bg-brand-900 text-brand-100/60 py-16 text-center border-t border-brand-800/50" data-id="element-72">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-73">
        <div className="font-serif font-medium text-white text-2xl mb-4 tracking-tight" data-id="element-74">
          Itera <span className="text-accent-400 italic" data-id="element-75">Pro</span>
        </div>
        <p className="text-sm leading-relaxed max-w-2xl mx-auto font-light" data-id="element-76">
          Sistema profesional para profesores de Yoga.
        </p>
        <div className="mt-12 text-xs text-brand-200/40 font-light" data-id="element-77">
          &copy; {new Date().getFullYear()} Mega Pack Yoga Listo. Todos los
          derechos reservados.
        </div>
      </div>
    </footer>;
}